import React from 'react';
import Dependent from "./Dependent";
import {DEPENDENT_TEMPLATE as template} from '../constants/generic';

const AddButton = (props) => {
    const onClick = () => {
        props.onClick(template);
    };

    return (
        <button className="btn btn-primary btn-sm" onClick={onClick}>Add</button>
    );
};

const Dependents = (props) => {
    const {dependents} = props;

    const onChange = (benefit, i, dependent) => {
        const list = [...dependents[benefit].list];
        list[i] = dependent;
        const d = {
            ...dependents,
            [benefit]: {...dependents[benefit], list}
        };

        props.onChange(d);
    };

    const onAdd = (benefit, template) => {
        const d = {
            ...dependents,
            [benefit]: {
                ...dependents[benefit],
                list: [...dependents[benefit].list, template]
            }
        };

        props.onChange(d);
    };

    const onDelete = (benefit, i) => {
        const d = {
            ...dependents,
            [benefit]: {
                ...dependents[benefit],
                list: dependents[benefit].list.filter((d, j) => {
                    return j !== i;
                })
            }
        };

        props.onChange(d);
    };

    return (
        <div className="dependents-wrapper mt-5">
            <h2>Dependents</h2>
            {Object.keys(dependents).map(benefit => {
                const {count, list, plan} = dependents[benefit];

                const canAdd = (count === null) || (count > list.length);

                return (
                    <React.Fragment key={benefit}>
                        {count !== 0 &&
                        <h3 className="font-weight-bold">
                            {benefit} {canAdd && <AddButton onClick={template => onAdd(benefit, template)}/>}
                        </h3>}

                        {list.map((dependent, i) => {
                            return (
                                <Dependent key={i}
                                           dependent={dependent}
                                           onChange={dependent => onChange(benefit, i, dependent)}
                                           onDelete={() => onDelete(benefit, i)}
                                           requireFacility={plan.requireFacility}
                                           deletable={i > 0}
                                />
                            );
                        })}

                        {canAdd &&
                        <div className="mb-5">
                            <AddButton onClick={template => onAdd(benefit, template)}/>
                        </div>}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default Dependents;
